import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ImageUploadField, PageHeader, useToast } from 'components/admin';
import { Button, Checkbox, Input, Select } from 'components/common';
import { createOrganizationChart, getAdminOrganizationChartById, updateOrganizationChart } from 'apis/adminOrganizationCharts';
import { getAdminLeaderCategories } from 'apis/adminLeaderCategories';
import { useAdminCreateMutation, useAdminDetailQuery, useAdminListQuery, useAdminUpdateMutation } from 'hooks';
import '../../../styles/admin-shared.scss';

const OrganizationChartsForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const toast = useToast();
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({ leaderCategoryId: '', imageUrl: '', sortOrder: 0, isActive: true });

    const { data: categoriesData = { items: [] } } = useAdminListQuery('leader-categories-options', { pageSize: 1000 }, getAdminLeaderCategories);
    const categories = categoriesData.items;
    const { data: detail, error: detailError } = useAdminDetailQuery('organization-charts', id, getAdminOrganizationChartById);
    const createMutation = useAdminCreateMutation('organization-charts', createOrganizationChart);
    const updateMutation = useAdminUpdateMutation('organization-charts', updateOrganizationChart);
    const loading = createMutation.isPending || updateMutation.isPending;

    useEffect(() => {
        if (detail) setFormData({ ...detail, leaderCategoryId: detail.leaderCategoryId || '' });
    }, [detail]);

    useEffect(() => { if (detailError) toast.error(detailError.message || 'T?i d? li?u th?t b?i'); }, [detailError, toast]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = { ...formData, leaderCategoryId: Number(formData.leaderCategoryId), sortOrder: Number(formData.sortOrder) };
            const res = id ? await updateMutation.mutateAsync({ id, data: payload }) : await createMutation.mutateAsync(payload);
            if (res.success) { toast.success(id ? 'Cập nhật thành công' : 'Thêm mới thành công'); navigate('/admin/organization-charts'); }
            else { if (res.messageError) setErrors(res.messageError); else toast.error(res.message || 'Lưu thất bại'); }
        } catch { toast.error('Lưu thất bại'); }
    };

    return (
        <div className="admin-page">
            <PageHeader title={id ? 'Cập nhật Sơ đồ Tổ chức' : 'Thêm Sơ đồ Tổ chức'} />
            <form className="form-card" onSubmit={handleSubmit}>
                <p className="form-section-title">Thông tin Sơ đồ</p>
                <Select
                    label="Danh mục Lãnh đạo *"
                    name="leaderCategoryId"
                    value={formData.leaderCategoryId}
                    onChange={handleChange}
                    options={[{ value: '', label: 'Chọn danh mục...' }, ...categories.map(c => ({ 
                        value: c.id, 
                        label: c.translations?.[0]?.name || c.name || `Category ${c.id}` 
                    }))]}
                    required
                    error={errors.leaderCategoryId}
                />
                <ImageUploadField
                    label="Hình ảnh sơ đồ *"
                    value={formData.imageUrl}
                    folder="organization-charts"
                    onChange={(imageUrl) => setFormData(prev => ({ ...prev, imageUrl }))}
                />
                <div className="form-row">
                    <Input label="Thứ tự sắp xếp" name="sortOrder" type="number" value={formData.sortOrder} onChange={handleChange} />
                </div>
                <Checkbox label="Hoạt động" name="isActive" checked={formData.isActive} onChange={handleChange} />
                <div className="form-actions">
                    <Button type="submit" disabled={loading}>{loading ? 'Đang lưu...' : id ? 'Cập nhật Sơ đồ' : 'Thêm Sơ đồ'}</Button>
                    <Button type="button" variant="secondary" onClick={() => navigate('/admin/organization-charts')}>Hủy</Button>
                </div>
            </form>
        </div>
    );
};

export default OrganizationChartsForm;
